export default __webpack_public_path__ + "static/media/GoldFrame06.7ef1195e.png";